import { render, staticRenderFns } from "./LockedEvent.vue?vue&type=template&id=ccd87590&scoped=true"
import script from "./LockedEvent.vue?vue&type=script&lang=js"
export * from "./LockedEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccd87590",
  null
  
)

export default component.exports